

export const colors = {
    // orangelight: '#F6D7B2',
    // orange: '#e69138',
    white: 'white',
    lightblue: '#E7ECF8',
    blue: '#a6afba',
    darkblue: '#203752',

    // https://www.color-hex.com/color/203752
    darkblue_lighter: '#4c5e74',
    red: '#D81D1D',
    grey: '#909BA9',
    grey2: '#8294A8'

}


export const constants = {
    FONT: {
        FAMILY: 'ROBOTO' /// unused
    },
    MAPAREA: {
        COLOR_BG: colors.white
    },
    SIDEBAR: {
        COLOR_BG: colors.lightblue
    },
    BLOCK: {
        WIDTH: 115,
        HEIGHT: 32,
        // HEIGHT: 32,
        BG_ODD: 'rgba(25,25,125,0.05)',
        COLOR_SELECTED: colors.blue,
        COLOR_SELECTED_LABEL: colors.darkblue,
        // COLOR_SELECTED_LABEL: colors.
    },
    GRID: {
        COLOR: 'lightgrey',
        WIDTH: 1,
        OPACITY: 0.5
    },
    CIRCLE: {
        RADIUS: 10,
        RADIUS_SELECTED: 12,
        // COLOR: 'rgba(118,126,237.6)',
        // COLOR: colors.darkblue,
        COLOR: colors.darkblue_lighter,
        COLOR_SELECTED: colors.red
    },
    CONNECTING_LINE: {
        COLOR: colors.darkblue,
        // COLOR: 'rgb(118,126,237)',
        WIDTH: 10,
        OPACITY: 0.4
    },
    HIGHLIGHT_LINE: {
        COLOR: {
            VERTICAL: colors.darkblue,
            HORIZONTAL: colors.darkblue,
        },
        WIDTH: {
            VERTICAL: 20,
            HORIZONTAL: 20
        },
        OPACITY: {
            VERTICAL: 0.3,
            HORIZONTAL: 0.3
        }
    }
}


